export const emptyMulticharIndex = {};
export const emptyRegularIndex = {};
function extendIndex(item, index) {
    let currentIndex = index;
    for (let pos = 0; pos < item.length; pos++) {
        const isLast = pos === item.length - 1;
        const char = item.charAt(pos);
        const charIndex = currentIndex[char] || (currentIndex[char] = { chars: {} });
        if (isLast) {
            charIndex.self = item;
        }
        currentIndex = charIndex.chars;
    }
}
export function createMulticharIndex(items) {
    if (items.length === 0) {
        return emptyMulticharIndex;
    }
    const index = {};
    for (const item of items) {
        extendIndex(item, index);
    }
    return index;
}
export function createRegularIndex(items) {
    if (items.length === 0) {
        return emptyRegularIndex;
    }
    const result = {};
    for (const item of items) {
        result[item] = true;
    }
    return result;
}
